// 标准数据路由
export default {
  path: "/basicdata",
  name: "basicdata",
  meta: { title: "基础数据", icon: "basic-data" },
  children: [
    {
      path: "/basicdata/productInfo",
      name: "productInfo",
      component: () =>
        import(
          /* webpackChunkName: "productInfo" */ "@/views/warehouse/basicData/productInfo"
        ),
      meta: { title: "产品信息", icon: "product" },
    },
    {
      path: "/basicdata/warehouseInfo",
      name: "warehouseInfo",
      component: () =>
        import(
          /* webpackChunkName: "returnInWarehouse" */ "@/views/warehouse/basicData/warehouseInfo"
        ),
      meta: { title: "仓库信息", icon: "warehouse" },
    },
  ],
};
